import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { keyBy } from '../../../../helpers/common'
import { COMPANY_TYPES } from '../../../../utils/common'
import useCompanyHeader from '../../../category/useCompanyHeader'
import { BLOCK_TYPE, factSheetTypes } from '../constants'
import {
  changeFactSheetChecked,
  selectData,
  selectDataAvailabilityDetails,
  selectFactSheetChecked,
} from '../store/slice'
import { ListCheckbox } from './ListCheckbox'
import { TableSelect } from './TableSelect'

export const FactSheetContent = ({ type, orgId, isHiddenPrice }) => {
  const dispatch = useDispatch()
  const { companyHeader } = useCompanyHeader({
    isFullInfo: false,
    orgId,
    disableCallApi: !orgId,
  })

  const data = useSelector(selectData)
  const factSheetChecked = useSelector(selectFactSheetChecked)
  const dataById = keyBy(data.dataBlocks || [], 'id')
  const availabilityDetails = useSelector(selectDataAvailabilityDetails)

  const isHidden = [
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.SECURITIES,
    COMPANY_TYPES.NON_BANK,
    COMPANY_TYPES.LIFE_INSURANCE,
    COMPANY_TYPES.NON_LIFE_INSURANCE,
  ].includes(companyHeader?.companyType)

  useEffect(() => {
    if (isHidden) {
      dispatch(changeFactSheetChecked({ [BLOCK_TYPE.SCORE]: false }))
    }
  }, [companyHeader])

  useEffect(() => {
    dispatch(
      changeFactSheetChecked({
        [BLOCK_TYPE.FINANCIAL_STATEMENT]:
          !!data.dataAvailabilityDetails?.length,
        [BLOCK_TYPE.INDUSTRY]: !!data.dataAvailabilityDetails?.length,
      }),
    )
  }, [data.dataAvailabilityDetails])

  const onCheckboxChange = (key, value) => {
    const newValue = { [key]: value }

    if (key === BLOCK_TYPE.FINANCIAL_STATEMENT) {
      newValue[BLOCK_TYPE.INDUSTRY] = value
    }

    dispatch(changeFactSheetChecked(newValue))
  }

  return (
    <div>
      {[factSheetTypes.PREVIEW, factSheetTypes.POPUP_LITE].includes(type) && (
        <>
          <ListCheckbox
            data={dataById}
            ids={[BLOCK_TYPE.COMPANY_PROFILE, BLOCK_TYPE.OWNERSHIP_GROUP]}
            checked={factSheetChecked}
            onCheckboxChange={onCheckboxChange}
            isHiddenPrice={isHiddenPrice}
          />
          <ListCheckbox
            data={dataById}
            ids={[BLOCK_TYPE.FINANCIAL_STATEMENT]}
            checked={factSheetChecked}
            onCheckboxChange={onCheckboxChange}
            isHiddenPrice={isHiddenPrice}
            allowChange={!!availabilityDetails.length}
            style={{ marginTop: 12 }}
          />
        </>
      )}
      {(type === factSheetTypes.POPUP_OTHERS ||
        factSheetChecked[BLOCK_TYPE.FINANCIAL_STATEMENT]) && (
        <TableSelect type={type} orgId={orgId} isHiddenPrice={isHiddenPrice} />
      )}
      {[factSheetTypes.PREVIEW, factSheetTypes.POPUP_LITE].includes(type) && (
        <>
          <ListCheckbox
            data={dataById}
            ids={[BLOCK_TYPE.SCORE]}
            checked={factSheetChecked}
            onCheckboxChange={onCheckboxChange}
            allowChange={!isHidden}
            style={{ marginTop: 12 }}
            isHiddenPrice={isHiddenPrice}
          />
          <ListCheckbox
            data={dataById}
            ids={[BLOCK_TYPE.INDUSTRY]}
            checked={factSheetChecked}
            onCheckboxChange={onCheckboxChange}
            style={{ marginTop: 12 }}
            isHiddenPrice={isHiddenPrice}
          />
        </>
      )}
    </div>
  )
}

FactSheetContent.propTypes = {
  type: PropTypes.string,
  orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isHiddenPrice: PropTypes.bool,
}

FactSheetContent.defaultProps = {
  isHiddenPrice: false,
}
